module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "payment-links-modal dark-top",
    attrs: {
      "dialog": "modal-lg"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center mb-1"
  }, [_c('h2', {
    staticClass: "m-0"
  }, [_vm._v("Payment Link Details")]), _vm._v(" "), (_vm.paymentLink) ? _c('span', {
    staticClass: "ml-2 lightest px-2 py-1 fs-normal radius-normal",
    class: _vm.statusConfig.cssClass
  }, [_vm._v(_vm._s(_vm.statusConfig.label))]) : _vm._e()]), _vm._v(" "), (_vm.paymentLink) ? _c('a', {
    staticClass: "reservation-link pointer",
    attrs: {
      "href": _vm.reservationUrl,
      "target": "_blank"
    }
  }, [_vm._v("Booking Nº: "), _c('span', {
    staticClass: "reservation-link__number"
  }, [_vm._v(_vm._s(_vm.paymentLink.reservation))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bg-lighter",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.confirmAction) ? _c('div', {
    staticClass: "w-100 px-4 py-5 bg-lightest text-center"
  }, [_c('p', {
    staticClass: "fs-large font-weight-600"
  }, [(_vm.confirmAction === 'cancel') ? _c('span', [_vm._v("Cancel the Payment Link?")]) : _vm._e(), _vm._v(" "), (_vm.confirmAction === 'save') ? _c('span', [_vm._v("Confirm the changes to the Payment Link?")]) : _vm._e()])]) : _c('div', {
    staticClass: "w-100 px-4 py-4 bg-lightest"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "form-col"
  }, [_c('label', [_vm._v("Amount "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (!_vm.canEditValue ? 'The amount cannot be changed for Multibanco payments.' : ''),
      expression: "!canEditValue ? 'The amount cannot be changed for Multibanco payments.' : ''"
    }],
    staticClass: "d-flex w-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.value),
      expression: "form.value"
    }, {
      name: "numFloat",
      rawName: "v-numFloat"
    }],
    staticClass: "fs-normal bg-lighter glued-right input-amount-width",
    class: {
      'input--readonly': _vm.isReadonly
    },
    attrs: {
      "type": "text",
      "placeholder": "0",
      "readonly": _vm.isReadonly || !_vm.canEditValue
    },
    domProps: {
      "value": (_vm.form.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "border-light d-flex justify-content-center glued-left fs-normal currency-width"
  }, [_vm._v("€")])]), _vm._v(" "), (_vm.isValueExceedingDue) ? _c('span', {
    staticClass: "fs-small color-6 mt-1 d-block error-message"
  }, [_vm._v("The payment amount cannot exceed the amount due.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-col"
  }, [_c('label', [_vm._v("Expiration date "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "expiration-container"
  }, [(_vm.expirationDatePart) ? [_c('input', {
    staticClass: "expiration-date-width",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.expirationDatePart
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "expiration-separator"
  }), _vm._v(" "), _c('input', {
    staticClass: "expiration-time-width text-center",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.expirationTimePart ? _vm.expirationTimePart + ' h' : ''
    }
  })] : _c('span', [_vm._v("No expiration date")])], 2)]), _vm._v(" "), (_vm.isLinkVisible) ? _c('div', {
    staticClass: "form-col form-col--full"
  }, [_c('label', [_vm._v("Payment Link URL")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100"
  }, [_c('input', {
    staticClass: "flex-grow-1 bg-lighter",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.paymentLink && _vm.paymentLink.url
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dark border-dark radius-normal d-flex align-items-center px-2 py-1 pointer bg-lightest fs-smaller ml-2",
    on: {
      "click": _vm.copyUrl
    }
  }, [_c('i', {
    staticClass: "ico ico-notes fs-smaller"
  }), _vm._v("\n                            Copy\n                        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-col form-col--full"
  }, [_c('label', [_vm._v("Notes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "w-100",
    class: {
      'input--readonly': _vm.isReadonly
    },
    attrs: {
      "type": "text",
      "readonly": _vm.isReadonly,
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.isReadonly) ? _c('span', {
    staticClass: "fs-small mt-1 d-block text-right",
    class: {
      'color-6': (_vm.form.description || '').length > 50
    }
  }, [_vm._v(_vm._s((_vm.form.description || '').length) + "/50")]) : _vm._e()])])])]), _vm._v(" "), (_vm.confirmAction) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel widest",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmAction = null
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok widest",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.executeConfirm
    }
  }, [_vm._v("Confirm")])]) : _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.isPending) ? _c('button', {
    staticClass: "btn action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmAction = 'cancel'
      }
    }
  }, [_vm._v("Cancel Payment")]) : _vm._e(), _vm._v(" "), (_vm.isPending) ? _c('button', {
    staticClass: "btn ok",
    attrs: {
      "type": "button",
      "disabled": !_vm.hasChanges || _vm.isValueExceedingDue
    },
    on: {
      "click": function($event) {
        _vm.confirmAction = 'save'
      }
    }
  }, [_vm._v("Update Payment")]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3a157e6a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a157e6a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/PaymentLinkDetails.vue
// module id = 1567
// module chunks = 0